import { CaseReducer, PayloadAction, createSlice } from '@reduxjs/toolkit';

import { get } from 'api/requests';
import { loading } from 'store/common';

import { IReducer, AppThunk } from 'store/types';
import { MediaEngineerings, EngNetInfoProps } from 'features/EngineeringNetStatus/types';

interface IMediaEngineeringsState {
  loading: boolean;
  media: MediaEngineerings;
  mediaWithStatusNotReady: MediaEngineerings;
}

const initialState: IMediaEngineeringsState = {
  loading: false,
  media: {
    media: [],
    id: null,
  },
  mediaWithStatusNotReady: {
    media: [],
    id: null,
  },
};

const reset: IReducer<IMediaEngineeringsState, IMediaEngineeringsState> = () => initialState;

const mediaEngineerings: CaseReducer<IMediaEngineeringsState, PayloadAction<MediaEngineerings>> = (
  state,
  action,
) => {
  state.media = action.payload;
};

const mediaEngineeringsWithStatusNotReady: CaseReducer<
  IMediaEngineeringsState,
  PayloadAction<MediaEngineerings>
> = (state, action) => {
  state.mediaWithStatusNotReady = action.payload;
};

export const mediaEngineeringsSlice = createSlice({
  name: 'MODAL/mediaEngineerings',
  initialState,
  reducers: {
    loading: loading as IReducer<IMediaEngineeringsState, boolean>,
    mediaEngineerings,
    mediaEngineeringsWithStatusNotReady,
    reset,
  },
});

const {
  loading: setLoading,
  mediaEngineerings: setMediaEngineerings,
  mediaEngineeringsWithStatusNotReady: setMediaEngineeringsWithStatusNotReady,
} = mediaEngineeringsSlice.actions;

export const getMediaEngineerings = (props: EngNetInfoProps): AppThunk => {
  return dispatch => {
    get<MediaEngineerings>(
      `/api/v2/standards/engineering_networks/${Number(props.networkId)}/media/`,
      props,
    ).then(({ data }) => {
      dispatch(setMediaEngineerings(data));
    });
  };
};

export const getMediaEngineeringsWithStatusNotReady = (props: EngNetInfoProps): AppThunk => {
  return dispatch => {
    get<MediaEngineerings>(
      `/api/v2/standards/engineering_networks/${Number(props.networkId)}/media_reasons/`,
      props,
    ).then(({ data }) => {
      dispatch(setMediaEngineeringsWithStatusNotReady(data));
    });
  };
};

export { setLoading };
